var _ = require('underscore');
var numeral = require('numeral');

var regex = {
    currency: /^\$?\d+(,\d+)*(\.\d+)?$/,
    integer: /^\d+$/,
    decimal: /^\d+(,\d+)*(\.\d+)?$/,
};

// Currency
module.exports.Currency = {
    encode: function (val) {
        if (val && regex.currency.test(val)) {
            return numeral(val).value();
        }
        return val;
    },
    decode: function (val) {
        if (!_.isNull(val) && !_.isUndefined(val)) {
            return numeral(val).format('0,0[.]00');
        }
        return val;
    },
};
